
const TABLE_TOP = 
  `<div class="table-responsive">
   <table class="table table-autofit table-valign-top">`.replace(/^\s*/gm, '');

const TABLE_BOTTOM = 
  `</table>
   </div>`.replace(/^\s*/gm, '');

export function prettifyHtml (html = ''): string {
  return html.replace(/(<table>|<\/table>|<td>|<th>)/g, (tag) => {

    switch (tag) {
      case '<table>': return TABLE_TOP;
      case '</table>': return TABLE_BOTTOM;
      case '<td>': return '<td class="table-cell-expand">';
      case '<th>': return '<th class="table-cell-expand">';
      default: return `Not handled "${tag}"`
    }
  });
}
